var $b993bdf137808db7$exports = {};
$b993bdf137808db7$exports = {
    "help": `Spikker`,
    "info": `Teave`
};


export {$b993bdf137808db7$exports as default};
//# sourceMappingURL=et-EE.mjs.map
